import { useEffect, useMemo, useState } from 'react';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';
import type React from 'react';

import { cmApi } from '@src/api';
import type { TableComponentRequestDto } from '@src/api';
import type { PagesParamInterface } from '@stores/dataControlStore';

interface IPremise {
  step_num: string;
  res_text: string;
}

export const useGetPremiseData = (
  lastPagesParam: PagesParamInterface,
  setIsPremiseLoadingDone: React.Dispatch<React.SetStateAction<boolean>>,
): IPremise[] => {
  const [premiseData, setPremiseData] = useState<IPremise[]>([]);

  useEffect(() => {
    const tableInfo = {
      fields: ['step_num', 'res_text'],
      hardFilter: [
        [
          ...(lastPagesParam.filters?.[0] ?? []),
          { name: 'expr_type', type: FILTER.EQ, values: ['premise'], filterIsInverted: false },
        ],
      ],
      limit: 100,
      offset: 0,
      resource: 'v_ctrl_step',
    };

    cmApi.tableComponentV2.getTableJson(tableInfo as unknown as TableComponentRequestDto).then((response) => {
      const result = response?.data as unknown as { data: { step_num: string; res_text: string }[] };
      if (result && result.data && result.data.length > 0) {
        setPremiseData(result.data);
      }
      setIsPremiseLoadingDone(true);
    });
  }, [lastPagesParam.filters, setIsPremiseLoadingDone]);

  return useMemo(() => premiseData, [premiseData]);
};
